import confirmation from "./confirmation";
import events from "./events";
import transport from "./transport";

export default () => {
	confirmation();
	events();
    transport();
}
